module.exports = __webpack_public_path__ + "img/img-2.906aff26.png";